import { BAILocale } from '.';
import ja_JP from 'antd/es/locale/ja_JP';

const localeValue: BAILocale = {
  lang: 'ja',
  antdLocale: ja_JP,
};

export default localeValue;
